<script>
import 'vue-select/dist/vue-select.css'
import Multiselect from 'vue-multiselect'
import { axiosGetPost } from '@router/axiosGetPost'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { formatDate, parseDate } from '@router/date-utils'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'AddMetricsExport',
  components: {
    Multiselect,
    DateRangePicker,
  },
  data() {
    return {
      modules: ['FCL', 'LCL'],
      validation: {},
      module: 'FCL',
    }
  },
  validations: {
    module: { required },
    validation: { required },
  },
  computed: {},
  created() {
    this.validation.startDate = this.calculateOneMonthAgo()
    this.validation.endDate = new Date().toISOString().slice(0, 10)
  },
  mounted() {},
  methods: {
    calculateOneMonthAgo() {
      const date = new Date()
      date.setMonth(date.getMonth() - 1)
      return date.toISOString().slice(0, 10) // Format the date as 'yyyy-mm-dd'
    },
    validate_fields() {
      let response = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$toastr.e('Field is required')
        console.log('error')
        response = false
      }
      return response
    },
    save() {
      console.log('hay click')
      if (this.validate_fields()) {
        console.log('hay click 2')
        this.loadingData = true
        axiosGetPost(
          'post',
          '/metricsApp/storeRequestExport',
          {
            module: this.module,
            date_from: this.validation.startDate,
            date_to: this.validation.endDate,
          },
          'Request Export Metrics'
        ).then((response) => {
          this.loadingData = false
          console.log(response)
          if (response.success) {
            this.$toastr.s('Success Export Metrics')
            this.$emit('close_modal')
          } else {
            this.errorShow = true
            this.error = 'Error to save'
            this.$toastr.e(response.messages)
            this.$emit('close_modal')
          }
          return response
        })
      }
    },
  },
}
</script>

<template>
  <div>
    <div class="form-group row">
      <div class="col-md-12">
        <div class="form-group row">
          <div class="col-md-2"> </div>
          <div class="col-md-4">
            <label>Module</label>
            <multiselect
              id="module"
              v-model="module"
              :options="modules"
              select-label=""
              placeholder="Select one"
              class="mt-0 mt-sm-0 mb-0"
            >
            </multiselect>
            <div v-if="$v.module.$error" style="color: red">
              * This value is required.
            </div>
          </div>
          <div class="col-md-4">
            <label>Validation</label>
            <date-range-picker
              opens="center"
              :locale-data="{
                format: 'yyyy-mm-dd',
                separator: ' / ',
                direction: 'ltr',
              }"
              class="col-md-12"
              v-model="validation"
              timezone="local"
            >
            </date-range-picker>
            <div v-if="$v.validation.$error" style="color: red">
              * This value is required.
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center mt-3">
            <!-- Asegúrate de añadir un margen en la parte superior para separar el botón del último elemento de tu formulario -->
            <b-button variant="primary" class="col-4" @click="save"
              >Submit</b-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>